import type { MouseEvent } from 'react';
import { useCallback } from 'react';
import { useWorkflowStore } from '../store';

/** @name 画板交互事件 */
export const usePanelInteractions = () => {
  const workflowStore = useWorkflowStore();

  const handlePaneContextMenu = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      // console.log(e)
      // const container = document.querySelector('#workflow-container');
      // console.log(container)
      // const { x, y } = container!.getBoundingClientRect();
      // console.log(x, y)
      const x = 0, y = 110;
      workflowStore.setState({
        panelMenu: {
          top: e.clientY - y,
          left: e.clientX - x,
        },
      });
    },
    [workflowStore],
  );

  const handlePaneContextmenuCancel = useCallback(() => {
    workflowStore.setState({
      panelMenu: undefined,
    });
  }, [workflowStore]);

  const handleNodeContextmenuCancel = useCallback(() => {
    workflowStore.setState({
      nodeMenu: undefined,
    });
  }, [workflowStore]);

  return {
    handlePaneContextMenu,
    handlePaneContextmenuCancel,
    handleNodeContextmenuCancel,
  };
};
